import(/* webpackMode: "eager" */ "/Users/ejazkhan/Documents/sealRepos/seal-business/src/app/about/page.tsx");
